import { loader } from "./actions.tsx";
import ValidatePage from "./validate.tsx";

export default {
  path: "/validate-envelope/:id",
  loader,
  Component: ValidatePage,
};
